import { Routes } from '@angular/router'

export const InventoryRoutes: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('@/app/domains/erp/inventory/pages/inventory-management/inventory-management.page').then(
                (m) => m.InventoryManagementPage
            ),
    },
    {
        path: 'products-list',
        loadComponent: () =>
            import('@/app/domains/erp/inventory/pages/products-list/products-list.page').then(
                (m) => m.ProductsListPage
            ),
    },
    {
        path: 'replenishment-summary',
        loadComponent: () =>
            import(
                '@/app/domains/erp/inventory/pages/replenishment-summary/replenishment-summary.page'
            ).then((m) => m.ReplenishmentSummaryPage),
    },
    {
        path: 'price-adjustment',
        loadComponent: () =>
            import('@/app/domains/erp/inventory/pages/price-adjustment/price-adjustment.page').then(
                (m) => m.PriceAdjustmentPage
            ),
    },
    {
        path: 'resource-tagging',
        loadComponent: () =>
            import('@/app/domains/erp/inventory/pages/resource-tagging/resource-tagging.page').then(
                (m) => m.ResourceTaggingPage
            ),
    },
    {
        path: 'low-rotation-products',
        loadComponent: () =>
            import(
                '@/app/domains/erp/inventory/pages/low-rotation-products/low-rotation-products.page'
            ).then((m) => m.LowRotationProductsPage),
    },
    {
        path: 'products-nearing-expiration',
        loadComponent: () =>
            import(
                '@/app/domains/erp/inventory/pages/products-nearing-expiration/products-nearing-expiration.page'
            ).then((m) => m.ProductsNearingExpirationPage),
    },
    {
        path: 'waste-entry',
        loadComponent: () =>
            import('@/app/domains/erp/inventory/pages/waste-entry/waste-entry.page').then(
                (m) => m.WasteEntryPage
            ),
    },
    {
        path: 'resource-edit/inventory-edit',
        loadComponent: () =>
            import('@/app/domains/erp/inventory/pages/inventory-edit/inventory-edit.page').then(
                (m) => m.InventoryEditPage
            ),
    },
    {
        path: 'material-list-edit',
        loadComponent: () =>
            import('../pages/material-list-edit/material-list-edit.page').then(
                (m) => m.MaterialListEditPage
            ),
    },
    {
        path: '**',
        redirectTo: '',
        pathMatch: 'full',
    },
]
